import { z } from "zod"
import { Element } from "../element"

// Version 1 ---------------------
export const DivSettingsV1 = z.object({
  style: z.string(),
  initialStyles: z.object({}).passthrough().optional(),
})

export type TDivSettingsV1 = z.infer<typeof DivSettingsV1>

export const DivElementV1 = z.object({
  id: z.string(),
  name: z.literal("div"),
  customName: z.string().optional(),
  settings: DivSettingsV1,
  children: z.lazy(() => z.array(Element)),
})

export type TDivElementV1 = z.infer<typeof DivElementV1>

// Latest ---------------------
export const DivSettings = DivSettingsV1
export type TDivSettings = TDivSettingsV1
export const DivElement = DivElementV1
export type TDivElement = TDivElementV1
